<template>
  <v-card>
    <v-card-title class="primary white--text">
      {{$t('copyFromAnotherTract')}}
      <v-spacer/>
      <Icon
        iconColor="tertiary"
        icon="mdi-close"
        :small="false"
        :large="true"
        :tooltipText="$t('close')"
        @icon-clicked="$emit('cancel')"
        elementId="copy-from-tract-close"
      />
    </v-card-title>
    <v-card-text class="pt-3">
      <v-select
        v-model="selectedTract"
        :items="tracts"
        :item-text="tractDisplayText"
        item-value="tractId"
        return-object
        :label="$t('selectSourceTract')"
        :no-data-text="$t('noOtherTractsInGroup')"
        outlined
        dense
      />
      <v-alert
        v-if="warningText"
        class="mb-5 mt-n2"
        color="red"
        elevation="2"
        outlined
        text
        dismissible
        dense
      >
        {{ warningText }}
      </v-alert>
    </v-card-text>
    <v-card-actions class="mt-n8">
      <v-spacer/>
      <v-btn
        color="primary"
        :disabled="!selectedTract"
        :loading="loading"
        @click="$emit('confirm', selectedTract)"
      >
        {{$t('confirm')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CopyFromTractDialog',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    tracts: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    warningText: {
      type: String,
      default: null
    }
  },

  data: () => ({
    selectedTract: null
  }),

  methods: {
    tractDisplayText (tract) {
      return tract.name
    }
  }
}
</script>
